import ApiService from "@/core/services/api.service";
import UIMixin from "@/mixins/UIMixin";

export default {
  mixins: [UIMixin],
  methods: {
    async getProvinceCities(callback) {
      let provinceCities = [];
      await ApiService.get("api/v2/provinces")
        .then(({ data }) => {
          provinceCities.push({
            id: null,
            text: this.$t(`${this.I18nPrefix}NOT_SELECTED`),
          });
          if (!data.code) {
            for (let i = 0; i < data.length; i++) {
              let province = data[i];
              for (let j = 0; j < province.city.length; j++) {
                let city = province.city[j];
                provinceCities.push({
                  id: city.id,
                  text: `${province.name} - ${city.name}`,
                });
              }
            }
            callback(provinceCities);
          }
        })
        .catch(() => {
          callback([]);
        });
    },

    getJobFields(callback) {
      let jobCategories = [];
      ApiService.get("api/get_job_field")
        .then((res) => {
          res.data.forEach((item) =>
            jobCategories.push({ id: item.id, text: item.name })
          );
          callback(jobCategories);
        })
        .catch(() => {
          callback([]);
        });
    },

    getJobCategories(callback) {
      let jobCategories = [];
      ApiService.get("api/v2/job-categories")
        .then((res) => {
          jobCategories.push({
            id: null,
            text: this.$t(`${this.I18nPrefix}NOT_SELECTED`),
          });
          res.data.forEach((item) =>
            jobCategories.push({ id: item.id, text: item.name })
          );
          callback(jobCategories);
        })
        .catch(() => {
          callback([]);
        });
    },

    gregorianToJalali(isoDate) {
      let newDate = new Date(isoDate);
      return this.toPersianDigits(this.$moment(newDate).format("YYYY/MM/DD"));
    },

    jalaliToGregorian(jy, jm, jd, endOfDay = false, time) {
      var gy, gm, gd, days, sal_a, v;
      if (jy > 979) {
        gy = 1600;
        jy -= 979;
      } else {
        gy = 621;
      }
      days =
        365 * jy +
        parseInt(jy / 33) * 8 +
        parseInt(((jy % 33) + 3) / 4) +
        78 +
        jd +
        (jm < 7 ? (jm - 1) * 31 : (jm - 7) * 30 + 186);
      gy += 400 * parseInt(days / 146097);
      days %= 146097;
      if (days > 36524) {
        gy += 100 * parseInt(--days / 36524);
        days %= 36524;
        if (days >= 365) days++;
      }
      gy += 4 * parseInt(days / 1461);
      days %= 1461;
      if (days > 365) {
        gy += parseInt((days - 1) / 365);
        days = (days - 1) % 365;
      }
      gd = days + 1;
      sal_a = [
        0,
        31,
        (gy % 4 == 0 && gy % 100 != 0) || gy % 400 == 0 ? 29 : 28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31,
      ];
      for (gm = 0; gm < 13; gm++) {
        v = sal_a[gm];
        if (gd <= v) break;
        gd -= v;
      }
      if (endOfDay) return gy + "-" + gm + "-" + gd + " 23:59:59";
      else if (time) return gy + "-" + gm + "-" + gd + " " + time;
      else return gy + "-" + gm + "-" + gd + " 00:00:00";
    },

    copyJobLink(id) {
      let linkJobToCopy = document.querySelector("#jobLink" + id);
      linkJobToCopy.setAttribute("type", "text");
      linkJobToCopy.select();
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "کپی شد" : "کپی نشد";
        // this.makeToast("موفق", msg, "success");
        this.successToast(msg);
      } catch (err) {
        // this.makeToast("متاسفیم!", msg, "danger");
        this.errorToast(msg);
      }
      linkJobToCopy.setAttribute("type", "text");
      window.getSelection().removeAllRanges();
    },

    copyJobIframeLink(jobId) {
      let iframesCodeToCopy = document.querySelector("#jobIframe" + jobId);
      iframesCodeToCopy.setAttribute("type", "success");
      iframesCodeToCopy.select();
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "کپی شد" : "کپی نشد";
        this.successToast(msg);
      } catch (err) {
        this.errorToast(msg);
      }
      iframesCodeToCopy.setAttribute("type", "success");
      window.getSelection().removeAllRanges();
    },

    createHTMLPageLinkForJob(companyId, jobId = null) {
      let jsLink =
        window.location.origin +
        "/js/import-resume-register-in-employer-site.js";
      if (jobId == null)
        return `<div id='secondcv' data-company="${companyId}"></div><script src="${jsLink}"></script>`;
      return `<div id='secondcv' data-company="${companyId}" data-job="${jobId}"></div><script src="${jsLink}"></script>`;
    },

    logoutWhenRefreshExpired() {
      localStorage.clear();
      document.location.reload();
    },

    getClientInfo() {
      const UNKNOWN = "-";

      // Get screen information
      const screenWidth = screen.width || UNKNOWN;
      const screenHeight = screen.height || UNKNOWN;
      const screenSize = `${screenWidth} x ${screenHeight}`;

      // Get browser information
      const nAgt = navigator.userAgent;
      let browser = UNKNOWN;
      let version = UNKNOWN;
      let majorVersion = UNKNOWN;

      const browserData = [
        {
          name: "Opera",
          pattern: /Opera|OPR/,
          versionPattern: /(?:Opera|OPR)[\\/\s](\d+\.\d+)/,
        },
        {
          name: "Microsoft Legacy Edge",
          pattern: /Edge/,
          versionPattern: /Edge\/(\d+\.\d+)/,
        },
        {
          name: "Microsoft Edge",
          pattern: /Edg/,
          versionPattern: /Edg\/(\d+\.\d+)/,
        },
        {
          name: "Internet Explorer",
          pattern: /MSIE|Trident/,
          versionPattern: /(?:MSIE |rv:)(\d+\.\d+)/,
        },
        {
          name: "Chrome",
          pattern: /Chrome/,
          versionPattern: /Chrome\/(\d+\.\d+)/,
        },
        {
          name: "Safari",
          pattern: /Safari/,
          versionPattern: /Version\/(\d+\.\d+)/,
        },
        {
          name: "Firefox",
          pattern: /Firefox/,
          versionPattern: /Firefox\/(\d+\.\d+)/,
        },
      ];

      for (const data of browserData) {
        if (data.pattern.test(nAgt)) {
          browser = data.name;
          const match = nAgt.match(data.versionPattern);
          version = match ? match[1] : UNKNOWN;
          break;
        }
      }

      majorVersion = parseInt(version, 10) || UNKNOWN;

      // Detect mobile devices
      const mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nAgt);

      // Check cookie support
      let cookies = navigator.cookieEnabled;
      if (typeof cookies === "undefined") {
        document.cookie = "testcookie";
        cookies = document.cookie.indexOf("testcookie") !== -1;
      }

      // Detect operating system
      let os = UNKNOWN;
      let osVersion = UNKNOWN;

      const osData = [
        { name: "Windows", pattern: /Windows NT (\d+\.\d+)/ },
        { name: "Mac OS", pattern: /Mac(?: OS X)? ([\d_\\.]+)/ },
        { name: "Android", pattern: /Android ([\d\\.]+)/ },
        { name: "iOS", pattern: /OS (\d+)[_.](\d+)[_.]?(\d+)?/ },
        { name: "Linux", pattern: /Linux/ },
        { name: "Chrome OS", pattern: /CrOS/ },
      ];

      for (const data of osData) {
        const match = nAgt.match(data.pattern);
        if (match) {
          os = data.name;
          osVersion = match.slice(1).filter(Boolean).join(".");
          break;
        }
      }

      // Ensure proper formatting for Windows OS version
      if (os === "Windows" && osVersion) {
        const windowsVersionMap = {
          "10.0": "10",
          6.3: "8.1",
          6.2: "8",
          6.1: "7",
          "6.0": "Vista",
          5.2: "Server 2003",
          5.1: "XP",
          "5.0": "2000",
        };
        osVersion = windowsVersionMap[osVersion] || osVersion;
      }

      return {
        screenSize,
        screenWidth,
        screenHeight,
        browser,
        browserVersion: version,
        browserMajorVersion: majorVersion,
        mobile,
        os,
        osVersion,
        cookies,
        userAgent: nAgt,
      };
    },

    insertVisit(visitorDetails) {
      ApiService.post("api/insertVisit", visitorDetails).then(function (
        response
      ) {
        if (!sessionStorage.getItem("soha_visitor_id"))
          sessionStorage.setItem("soha_visitor_id", response.data.param);
      });
    },
  },
};
